module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABL0lEQVQ4T92UMU7DQBBF/yxBtJtUdBgpdu2G3jfgCm6xG3MD3wA3dtocwdzA3MC0cZEbmG1JkAeNpUiOg5FJIoHYcld68//82SGc+dCZefg94CxbLZlJM6EwgZ0MORulUC8qDwxXQAJu3i8j83hrvoKOA2ZVBEJpHuxillZxs5kkJwGnaZXzZuILRBTWgeMfbVmnK1+BrDq0Y4FMs6p4C2xvFFAv1haa7T2BrhvmC6XojhgvO5hAdFZFiqEBCYhdZo5M6JS7Ans9lOoMSgC2FNj9zloLf1pruvrIu4oPgPIoqaoGXlfZkMV+C/4WUAIT5SZ0loM9/Inl7jidDJSJULyN+8Ed3cP2xxCVJpjn3cD2gO0CAN2AWRPoWVKWFAFwP2Vieq3DeXRw/3/24Vgnn0DLuhWGAyq4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ../assets/images/zan1.png
// module id = 2158
// module chunks = 0